// src/routes/AdminRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../context/AuthContext';
import { ROUTES } from '../constants/routes';

export default function AdminRoute() {
    const { user, loading, isAdmin } = useAuth();

    if (loading) {
        return (
            <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!user) return <Navigate to={ROUTES.LOGIN} replace />;
    return isAdmin ? <Outlet /> : <Navigate to={ROUTES.UNAUTHORIZED} replace />;
}